import { render, staticRenderFns } from "./PieChartWithList.vue?vue&type=template&id=77497483&"
import script from "./PieChartWithList.vue?vue&type=script&lang=js&"
export * from "./PieChartWithList.vue?vue&type=script&lang=js&"
import style0 from "./PieChartWithList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports